export default __webpack_public_path__ + "static/media/about-page-img.edbd41a7.JPG";